import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import ButtonCardAction from '../components/cardActions/ButtonCardAction';
import ActionLibraryButtonAction from '../components/cardActions/ActionLibraryButtonAction';
import LinkAction from '../components/cardActions/LinkCardAction';
import HubSpotAppLinkAction from '../components/cardActions/HubSpotAppLinkCardAction';
import DropdownAction from '../components/cardActions/DropdownCardAction';
import { ACTION_LIBRARY_BUTTON } from '../constants/CardActionType';
import { BUTTON, DROPDOWN, HUBSPOT_APP_LINK, LINK } from '../constants/CardActionType';
import { BUTTON as MODE_BUTTON } from '../constants/CardActionDisplayMode';
import { CARD_ACTION_FORMATTER_IFRAME_LOOKUP_KEYS } from '../constants/IframeLookupKeys';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CardActionButtonList({
  actionConfigs,
  mode = MODE_BUTTON
}) {
  if (!actionConfigs.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    children: actionConfigs.map((actionConfig, key) => {
      if (actionConfig.type === BUTTON) {
        return /*#__PURE__*/_jsx(ButtonCardAction, {
          actionConfig: actionConfig,
          mode: mode
        }, key);
      }
      if (actionConfig.type === ACTION_LIBRARY_BUTTON) {
        return /*#__PURE__*/_jsx(ActionLibraryButtonAction, {
          actionConfig: actionConfig,
          mode: mode
        }, key);
      }
      if (actionConfig.type === LINK) {
        return /*#__PURE__*/_jsx(LinkAction, {
          actionConfig: actionConfig,
          mode: mode
        }, key);
      }
      if (actionConfig.type === HUBSPOT_APP_LINK) {
        return /*#__PURE__*/_jsx(HubSpotAppLinkAction, {
          actionConfig: actionConfig,
          mode: mode
        }, key);
      }
      if (actionConfig.type === DROPDOWN) {
        return /*#__PURE__*/_jsx(DropdownAction, {
          actionConfig: actionConfig,
          mode: mode
        }, key);
      }
      return null;
    })
  });
}
CardActionButtonList.iframeLookupKey = CARD_ACTION_FORMATTER_IFRAME_LOOKUP_KEYS.CARD_ACTION_BUTTON_LIST;